<template>
  <div
    class="icon"
    :class="{ 'no-radius': listType == 'free' }"
    v-tooltip="{ content: tooltip, placement: 'right' }"
  >
    <BaseIconOpenFolder
      :listType="listType"
      :nameIcon="nameIcon"
      @click="importList"
    />
    <!--  <div v-if="false" @click="importList">
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32.000000 23.000000"
        preserveAspectRatio="xMidYMid meet"
        style="width: 20px;height:20px;margin-left: 3px"
      >
        <g
          transform="translate(0.000000,23.000000) scale(0.100000,-0.100000)"
          fill="#000000"
          stroke="none"
        >
          <path
            d="M10 136 c0 -46 3 -92 6 -100 5 -14 23 -16 108 -15 55 0 108 5 117 10
12 6 22 2 34 -11 10 -11 25 -20 33 -20 12 0 9 7 -10 28 -21 22 -24 31 -16 49
27 57 -36 123 -122 128 -28 1 -54 5 -57 9 -4 3 -26 6 -50 6 l-43 0 0 -84z m74
59 c3 -10 19 -15 43 -15 29 0 34 -3 25 -12 -7 -7 -29 -11 -51 -9 -35 2 -39 0
-53 -36 l-16 -38 -1 63 c-1 59 0 62 23 62 13 0 26 -7 30 -15z m164 -41 c15
-10 22 -25 22 -49 0 -58 -69 -86 -110 -45 -58 58 20 142 88 94z m-123 -34 c-4
-11 0 -34 9 -50 l14 -30 -54 0 c-30 0 -54 1 -54 3 0 2 7 24 16 50 14 42 19 47
46 47 25 0 28 -3 23 -20z"
          />
        </g>
      </svg>
    </div>
 -->
    <!-- <BaseIcon
      v-else
      class="icon-header"
      width="24"
      height="16"
      nameIcon="icon-folder-search-list-list"
      pathIcon="icons-folder"
      @click="importList"
    /> -->
  </div>
</template>

<script>
// import { mapGetters, mapActions, mapState } from "vuex";
export default {
  props: {
    listType: {
      type: String,
      default: "book",
    },
  },
  data() {
    return {
      nameIcon: "s",
      state: "open",
      showPopup: false,
    };
  },
  computed: {
    tooltip() {
      return this.listType === "book"
        ? this.$t("folders.openFolder")
        : this.$t("folders.openFreeList");
    },
  },
  methods: {
    importList() {
      this.$store.dispatch("folders/setOpenTypePopup", "import");
      this.$store.dispatch("folders/setListType", this.listType);
      this.$store.dispatch("folders/togglePopupFolder", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  padding-top: 8.75px;
}
</style>
